import Vue from 'vue'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserPlus, faUserTimes, faClipboardList, faSearch, faFileCsv, faFileArchive, faSync, faFilePdf, faPlus, faTrash, faPen, faFileExcel } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import locale from 'element-ui/lib/locale/lang/ua'
import App from './App.vue'
import router from './router'
import store from './store'

Bugsnag.start({
  apiKey: 'ebbe8279cb071c0b5fd01a93da5fc04f',
  plugins: [new BugsnagPluginVue()]
})

Vue.config.productionTip = false;

library.add(faUserPlus, faUserTimes, faClipboardList, faSearch, faFileCsv, faFileArchive, faSync, faFilePdf, faPlus, faTrash, faPen, faFileExcel);
Vue.component('font-awesome-icon', FontAwesomeIcon);


Vue.use(ElementUI, { locale });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Bugsnag.getPlugin('vue')
  .installVueErrorHandler(Vue)